export const DASHBOARD_SESSION_EXPIRED_EVENT = "playbrain:dashboard-session-expired"

export function notifyDashboardSessionExpired() {
  if (typeof window === "undefined") return
  window.dispatchEvent(new Event(DASHBOARD_SESSION_EXPIRED_EVENT))
}
